import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-4 mb-3" }
const _hoisted_5 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_6 = { class: "col-md-4 mb-3" }
const _hoisted_7 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_8 = { class: "col-md-4 mb-3" }
const _hoisted_9 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_10 = { class: "col-md-8 mb-3" }
const _hoisted_11 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_12 = ["onUpdate:modelValue"]
const _hoisted_13 = { class: "col-md-4 mb-3" }
const _hoisted_14 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_15 = {
  key: 0,
  class: "col-md-12 mb-md-25"
}
const _hoisted_16 = {
  class: "tab-pane fade show active p-10",
  id: "home-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "border border-primary mb-10" }
const _hoisted_19 = { class: "col-md-4 mb-2" }
const _hoisted_20 = { class: "form-group" }
const _hoisted_21 = ["onUpdate:modelValue"]
const _hoisted_22 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_23 = { class: "col-md-4 mb-2" }
const _hoisted_24 = { class: "form-group" }
const _hoisted_25 = ["onUpdate:modelValue"]
const _hoisted_26 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_27 = { class: "col-md-4 mb-2" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "col-md-12 mt-3" }
const _hoisted_30 = { class: "d-flex align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[14] || (_cache[14] = _createElementVNode("div", { class: "card-header" }, [
      _createElementVNode("h3", { class: "text-black fw-semibold" }, "Modifier une créance")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        ref: "creanceForm",
        onSubmit: _ctx.editCreance,
        "validation-schema": _ctx.creanceSchema,
        "initial-values": _ctx.creanceForm
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[3] || (_cache[3] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Date de la creance "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "dateCreance",
                  type: "date",
                  readonly: "",
                  class: "form-control shadow-none fs-md-15 text-black"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "dateCreance",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[4] || (_cache[4] = _createElementVNode("label", { class: "d-block text-black mb-10" }, [
                  _createTextVNode(" Client "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "client",
                  modelValue: _ctx.client,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.client) = $event)),
                  type: "text"
                }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field, {
                      options: _ctx.clientOptions,
                      "preserve-search": true,
                      multiple: false,
                      searchable: true,
                      placeholder: "Sélectionner le client",
                      label: "label",
                      "track-by": "label"
                    }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "client",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _cache[5] || (_cache[5] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, [
                  _createTextVNode(" Montant total de la créance "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  type: "number",
                  name: "montant",
                  modelValue: _ctx.montant,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.montant) = $event)),
                  class: "form-control shadow-none fs-md-15 text-black"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "montant",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _cache[6] || (_cache[6] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Motif de la créance "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "motifCreance",
                  cols: "20",
                  rows: "1",
                  as: "textarea",
                  placeholder: "Description",
                  class: "form-control shadow-none rounded-0 text-black"
                }, {
                  default: _withCtx(({ field }) => [
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                      class: "form-control shadow-none rounded-0 text-black"
                    }, null, 8, _hoisted_12), [
                      [_vModelText, field.value]
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "motifCreance",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _cache[7] || (_cache[7] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, [
                  _createTextVNode(" Nombre d'échéances "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  type: "number",
                  name: "nbreEcheance",
                  modelValue: _ctx.nbreEcheance,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.nbreEcheance) = $event)),
                  class: "form-control shadow-none fs-md-15 text-black"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "nbreEcheance",
                  class: "text-danger"
                })
              ])
            ]),
            (_ctx.nbreEcheance > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _cache[11] || (_cache[11] = _createElementVNode("div", {
                          class: "row d-flex align-items-center justify-content-between fw-bold py-2",
                          style: {"background-color":"#0a59a4"}
                        }, [
                          _createElementVNode("div", { class: "col-md-12" }, [
                            _createElementVNode("h3", { class: "fs-4 text-white" }, " Échéances ")
                          ])
                        ], -1)),
                        _createElementVNode("div", null, [
                          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "row d-flex align-items-center justify-content-between mt-10" }, [
                            _createElementVNode("div", { class: "col-md-4" }, [
                              _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                                _createTextVNode(" Date Échéance "),
                                _createElementVNode("span", { class: "text-danger" }, "*")
                              ])
                            ]),
                            _createElementVNode("div", { class: "col-md-4" }, [
                              _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                                _createTextVNode(" Montant "),
                                _createElementVNode("span", { class: "text-danger" }, "*")
                              ])
                            ]),
                            _createElementVNode("div", { class: "col-md-4" }, [
                              _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                                _createTextVNode(" Actions "),
                                _createElementVNode("span", { class: "text-danger" }, "*")
                              ])
                            ])
                          ], -1)),
                          _cache[10] || (_cache[10] = _createElementVNode("hr", { class: "mt-0" }, null, -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.echeances, (echeance, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "row",
                              key: index
                            }, [
                              _createElementVNode("div", _hoisted_19, [
                                _createElementVNode("div", _hoisted_20, [
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": ($event: any) => ((echeance.dateEcheance) = $event),
                                    name: "dateEcheance",
                                    type: "date",
                                    class: "form-control shadow-none fs-md-15 text-black",
                                    placeholder: "Saisir la date de l'échéance"
                                  }, null, 8, _hoisted_21), [
                                    [_vModelText, echeance.dateEcheance]
                                  ]),
                                  (_ctx.valideteRowEcheance(echeance.dateEcheance))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, " La date échéance est obligatoire. "))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_23, [
                                _createElementVNode("div", _hoisted_24, [
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": ($event: any) => ((echeance.montant) = $event),
                                    name: "montant",
                                    type: "number",
                                    class: "form-control shadow-none fs-md-15 text-black",
                                    placeholder: "Entrer le montant"
                                  }, null, 8, _hoisted_25), [
                                    [_vModelText, echeance.montant]
                                  ]),
                                  (_ctx.valideteRowEcheance(echeance.montant))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, " Le montant est obligatoire. "))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_27, [
                                _createElementVNode("button", {
                                  class: "btn btn-danger transition border-0 pb-2 ps-8 pe-8",
                                  type: "button",
                                  onClick: ($event: any) => (_ctx.removeRowEcheance(index))
                                }, _cache[8] || (_cache[8] = [
                                  _createElementVNode("i", { class: "fa fa-trash-o lh-1 me-1 position-relative top-2" }, null, -1)
                                ]), 8, _hoisted_28)
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _cache[13] || (_cache[13] = _createElementVNode("button", {
                  class: "btn btn-success me-3",
                  type: "submit"
                }, " Modifier une créance ", -1)),
                _createVNode(_component_router_link, {
                  to: "/creances/liste-creances",
                  class: "btn btn-danger"
                }, {
                  default: _withCtx(() => _cache[12] || (_cache[12] = [
                    _createElementVNode("i", { class: "fa fa-trash-o lh-1 me-1 position-relative top-2" }, null, -1),
                    _createElementVNode("span", { class: "position-relative" }, null, -1),
                    _createTextVNode("Annuler ")
                  ])),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema", "initial-values"])
    ])
  ]))
}